import { InflateRequestMode } from '@sccs/types';
import { RequestHeaderConfiguration } from '../../../types/ApiClientConfig';
import { SharedRequestConfiguration, SharedRequestOneSearchParameter } from '../../../types/GeneralParameter';
import {
  OneSearchPreferenceResponse,
  OptionalOneSearchPreferenceResponseWithId,
} from '../../../types/one-search/onesearch-response/OfferTeaserResponseDto';
import { convertFieldsToStrings } from '../../../util/ConvertPropertiesToString';
import {
  createMandatoryParameter,
  getRequestConfiguration,
  removeClassSuffixForOneSearch,
  removeClassSuffixFromMultipleIdentifier,
} from '../../../util/one-search/RequestConfiguration';
import { isCommercialVanByMode } from '../../../util/VansConfiguration';
import { GenericFetchClient, ModeSpecificFetchClient } from '../../GenericFetchClient';

export type OneSearchPreferences = SharedRequestOneSearchParameter & {
  classFilters?: string;
  brandFilters?: string;
  bodyTypeFilters?: string;
  modelId?: string;
  cookie?: string;
};

export class OneSearchPreferenceClient extends GenericFetchClient implements ModeSpecificFetchClient {
  constructor(config: RequestHeaderConfiguration) {
    super(config);
    this.setPathSegment('/preferences');
  }

  getInflateIdLength(): number {
    throw new Error('Method not implemented.');
  }

  setMode(): void {
    throw new Error('Method not implemented.');
  }

  setRequiredParameters(parameter: OneSearchPreferences, configuration: SharedRequestConfiguration): void {
    const additionalRequestConfig = this.getAdditionalRequestConfig(parameter, configuration);

    this.setQueryParameters({
      ...convertFieldsToStrings({
        ...additionalRequestConfig,
      }),
    });

    if (configuration.cookie) {
      this.setHeaderParameters({
        'X-APP-AS-SESSION-ID': configuration.cookie,
      });
    }
  }

  private getAdditionalRequestConfig(parameter: OneSearchPreferences, configuration: SharedRequestConfiguration) {
    const { brandFilters, oneSearchFilterPrefix } = createMandatoryParameter(parameter);
    this.setPathSegment(`/preferences/${oneSearchFilterPrefix}`);

    const classFilters = this.getClassFilterByMode(configuration.mode, parameter.classFilters);
    const isVan = isCommercialVanByMode(configuration.mode);

    return getRequestConfiguration(isVan, { ...parameter, classFilters, brandFilters });
  }

  private getClassFilterByMode(mode: string, classFilter: string | undefined): string {
    if (!classFilter) return '';
    switch (mode) {
      case InflateRequestMode.PI_PAGES_VANS:
        return classFilter; // VITO_TOURER won't be splitted here
      case InflateRequestMode.PI_PAGES_CARS:
        return removeClassSuffixForOneSearch(classFilter);
      case InflateRequestMode.HOMEPAGE_CARS:
      case InflateRequestMode.HOMEPAGE_VANS:
      case InflateRequestMode.CAMPAIGN_TEASER_CARS:
      case InflateRequestMode.CAMPAIGN_TEASER_VANS:
        return removeClassSuffixFromMultipleIdentifier(classFilter);
      default:
        throw new Error('Unknown Teaser Mode');
    }
  }

  checkAllRequiredParametersPresent(): boolean {
    throw new Error('Method not implemented.');
  }

  async getResponse(): Promise<OptionalOneSearchPreferenceResponseWithId> {
    const preferenceData = await this.fetchTypedBody<OneSearchPreferenceResponse>();
    return {
      responseTypeId: 'OneSearchPreferenceResponse',
      ...preferenceData,
    };
  }
}
